export interface IErrorProps {
  /**
   * If a boolean, this prop will cause the input show it's error state
   * If a string, this input will additionally render the error below the input
   */
  error?: string | boolean;
}

interface ShowErrorStateWithMessageProps {
  showErrorState: true;
  showErrorMessage: true;
  errorMessage: string;
}

interface ShowErrorStateProps {
  showErrorState: true;
  showErrorMessage: false;
  errorMessage: undefined;
}

interface NormalStateProps {
  showErrorState: false;
  showErrorMessage: false;
  errorMessage: undefined;
}

/**
 * Converts public error prop shorthands into distinct explicit props.
 * If you need proper type narrowing make sure not to destructure the returned
 * value!
 */
export const getDerivedPropsFromErrorProps = ({
  error,
}: IErrorProps):
  | ShowErrorStateWithMessageProps
  | ShowErrorStateProps
  | NormalStateProps => {
  if (error === true || error === "") {
    return {
      showErrorState: true,
      showErrorMessage: false,
      errorMessage: undefined,
    };
  }

  if (typeof error === "string") {
    return {
      showErrorState: true,
      showErrorMessage: true,
      errorMessage: error,
    };
  }

  return {
    showErrorState: false,
    showErrorMessage: false,
    errorMessage: undefined,
  };
};
